import './Print.css';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getDataObjArray, loadHoursCalendar, loadMinutesCalendar } from '../Sidebar/SideBarUtils';

function PrintBar({ timeIni, timeFim, onComboChange }) { 
    const { t } = useTranslation();
    const [defHrIni, setdefHrIni] = useState<string>('');
    const [defHrFim, setdefHrFim] = useState<string>('');
    const [defMinIni, setdefMinIni] = useState<string>('');
    const [defMinFim, setdefMinFim] = useState<string>(''); 

    let combHr =  loadHoursCalendar();
    let combMin = loadMinutesCalendar();

    useEffect(() => {
        setDefValues();
    }, [timeIni, timeFim]);

    function setDefValues() {
        setdefHrIni(timeIni.split(':')[0]);
        setdefMinIni(timeIni.split(':')[1]);
        setdefHrFim(timeFim.split(':')[0]);
        setdefMinFim(timeFim.split(':')[1]);
    }
    const trocaHrIni = event => {
        setdefHrIni(event.currentTarget.value);
        onComboChange('HrIni', event.currentTarget.value);
    }
    const trocaHrFim = event => {
        setdefHrFim(event.currentTarget.value);
        onComboChange('HrFim', event.currentTarget.value);
    }
    const trocaMinIni = event => {
        setdefMinIni(event.currentTarget.value);
        onComboChange('MinIni', event.currentTarget.value);
    }
    const trocaMinFim = event => {
        setdefMinFim(event.currentTarget.value);
        onComboChange('MinFim', event.currentTarget.value);
    } 
    return (

        <div data-testid="divPrintBar">
            <ul className='printbar-header' >
                <label>{t("rows.startingTime")}</label>
            </ul>
            <div className='printbar'>
                <ul className='printbar-div'>
                    <label >{t("rows.hour")}</label>
                    <select className='indice-combo' name="comboIniHr" value={defHrIni} onChange={trocaHrIni}>                        
                    {getDataObjArray(combHr).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)} 
                    </select>
                </ul>
                <ul className='printbar-div'>
                    <label >{t("rows.minute")}</label>
                    <select className='indice-combo' name="comboIniMin" value={defMinIni} onChange={trocaMinIni}>
                    {getDataObjArray(combMin).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)}                         
                    </select>
                </ul>
            </div>
            <ul className='printbar-header' >
                <label >{t("rows.endingTime")}</label>
            </ul>
            <div className='printbar'>
                <ul className='printbar-div'>
                    <label >{t("rows.hour")}</label>
                    <select className='indice-combo' name="comboFimHr" value={defHrFim} onChange={trocaHrFim}>
                    {getDataObjArray(combHr).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)} 
                    </select>
                </ul>
                <ul className='printbar-div'>
                    <label >{t("rows.minute")}</label>
                    <select className='indice-combo' name="comboFimMin" value={defMinFim} onChange={trocaMinFim}>
                    {getDataObjArray(combMin).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)}                     
                    </select>
                </ul>
            </div>
        </div >
    );
}

export default PrintBar;